$(document).ready(function() {

    $('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<div class="main-cart--wrapper page-width"></div>');

    setTimeout(function() {
        $(".boost-sd__filter-tree-vertical-option-list").before("<h4>Filter</h4>");
    }, 2000);

    $(".review_home_slider").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplaySpeed: 2500,
        speed: 1500,
        autoplay: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                arrows: false,
            },
        }, ],
    });



    $(".related_product .product-grid").slick({
        autoplay: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        infinite: true,
        arrows: false,
        dots: false,
        cssEase: "linear",
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".client_slider").slick({
        waitForAnimate: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipe: false,
        draggable: false,
        touchMove: false,
        autoplay: true,
        slidesToScroll: 1,
        slidesToShow: 8,
        infinite: true,
        speed: 2000,
        arrows: false,
        dots: false,
        cssEase: "linear",
        autoplaySpeed: 0,
        focusOnSelect: false,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                },
            },
        ],
    });

    $(".client_slider_two").slick({
        waitForAnimate: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipe: false,
        draggable: false,
        touchMove: false,
        autoplay: false,
        slidesToScroll: 1,
        slidesToShow: 6,
        infinite: true,
        // speed: 2000,
        arrows: true,
        dots: false,
        // cssEase: "linear",
        autoplaySpeed: 500,
        focusOnSelect: false,
        variableWidth: true,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    });

    if ($(window).width() < 991) {
        $(".client_text_wrap").slick({
            autoplay: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
            speed: 4000,
            arrows: false,
            dots: false,
            cssEase: "linear",
            variableWidth: true,
            autoplaySpeed: 0,
        });
    }

    if ($(window).width() < 767) {
        $(".collection_col_wrap .slider_for_mobile").slick({
            pauseOnHover: true,
            autoplay: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
            speed: 3000,
            arrows: false,
            dots: false,
            autoplaySpeed: 2000,
        });
    }

    // poster js
    $(".poster, .poster2").click(function() {
        $(this).addClass("poster-active");
        $(".poster iframe, .poster2 iframe").attr("src", function(index, oldSrc) {
            return oldSrc + "?autoplay=1";
        });
    });

    // footer menu accordion js
    $(".footer-block .footer-block__heading").on("click", function(e) {
        e.preventDefault();
        if ($(this).next("ul").is(":visible")) {
            $(this).removeClass("open");
            $(this).next(".ac-menu .footer-block ul").slideUp();
        } else {
            $(".ac-menu .footer-block .footer-block__heading").removeClass("open");
            $(this).addClass("open");
            $(".ac-menu .footer-block .footer-block__heading")
                .next(".ac-menu .footer-block ul")
                .slideUp();
            $(this).next(".ac-menu .footer-block ul").slideToggle();
        }
    });

    if ($(window).width() < 992) {
        $(".footer").addClass("ac-menu");
    } else {
        $(".footer").removeClass("ac-menu");
    }
    $(window).on("resize", function() {
        if ($(window).width() < 992) {
            $(".footer").addClass("ac-menu");
            $(".footer-block ul").css("display", "none");
        } else {
            $(".footer").removeClass("ac-menu");
            $(".footer-block ul").css("display", "block");
        }
    });

    /* frequently bought together */

    if ($(".frequent-item")[0]) {
        $(".minus-btn").on("click", function() {
            var quantityInput = $(this).siblings("input[name='quantity']");
            var currentValue = parseInt(quantityInput.val());
            if (currentValue > 0) {
                quantityInput.val(currentValue - 1);
            }
        });

        $(".quantity_button").attr("disabled", true);
        $(".quantity-get").attr("disabled", true);

        $(".form-check-input").change(function() {
            var quantityInput = $(this).closest(".form-check").find(".quantity-get");
            var quantityBtn = $(this).closest(".form-check").find(".quantity_button");
            if ($(this).is(":checked")) {
                quantityInput.attr("disabled", false);
                quantityBtn.attr("disabled", false);
            } else {
                quantityInput.attr("disabled", true);
                quantityBtn.attr("disabled", true);
            }
        });

        $(".frequent-item").after(
            '<button class="btn btn-default js-ajax-add-to-cart" style="display: none;"></button>'
        );
        $(".plus-btn").on("click", function() {
            var quantityInput = $(this).siblings("input[name='quantity']");
            var currentValue = parseInt(quantityInput.val());
            var userQty = parseFloat(quantityInput.val()) + 1;
            var actualQty = parseFloat(quantityInput.data("variant"));

            if (userQty > actualQty) {
                alert("You have exceeded the quantity");
                quantityInput.val("1");
            } else {
                quantityInput.val(currentValue + 1);
            }
        });

        $(".quantity-get").on("keyup", function() {
            var quantityInput = $(this);
            var actualQty = parseFloat(quantityInput.data("variant"));
            var userQty = parseFloat(quantityInput.val());

            if (userQty > actualQty) {
                alert("You have exceeded the quantity");
                quantityInput.val("1");
            }
        });

        $(document).on("click", ".product-form__submit ", function() {
            $(".js-ajax-add-to-cart").trigger("click");
        });

        $(document).on("click", ".form-check-input", function() {
            var checkbox = $(this);
            var quantityInput = checkbox.closest(".form-check").find(".quantity-get");

            if (checkbox.is(":checked")) {
                quantityInput.val("1");
            } else {
                quantityInput.val("0");
            }
        });

        var selectedVariants = [];

        $(document).on("click", ".form-check-input", function() {
            var checkbox = $(this);
            var variantId = checkbox.val();
            var quantity = checkbox
                .closest(".form-check")
                .find("input[name='quantity']")
                .val();

            if (checkbox.is(":checked") && quantity > 0) {
                var existingVariant = selectedVariants.find(function(variant) {
                    return variant.id === variantId;
                });

                if (existingVariant) {
                    existingVariant.quantity = quantity; // Update the quantity
                } else {
                    selectedVariants.push({
                        id: variantId,
                        quantity: quantity,
                    });
                }
            } else {
                selectedVariants = selectedVariants.filter(function(variant) {
                    return variant.id !== variantId;
                });
            }
        });

        $(".js-ajax-add-to-cart").click(function(event) {
            event.preventDefault();

            var mainProductId = $("body")
                .find("input.product-variant-id[name='id']")
                .val();
            var mainProductQuantity = $("body")
                .find("input.quantity__input[name='quantity']")
                .val();
            selectedVariants.push({
                id: mainProductId,
                quantity: mainProductQuantity,
            });
            var itemsArray = selectedVariants.map(function(variant) {
                return {
                    quantity: variant.quantity,
                    id: variant.id,
                };
            });
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    items: itemsArray,
                },
                dataType: "json",
                success: function(data) {
                    // Handle success
                },
                error: function(error) {
                    console.error("Error adding products to cart:", error);
                },
            });
        });
    }
    /* frequently bought together */

    /* custom product page code */
    // var append_li = "";
    // $(document)
    //     .find("variant-selects .product-form__input")
    //     .each(function(index) {
    //         var option_label = $.trim($(this).find("label").text());
    //         var option_values = $(this).find("select").find("option");
    //         var indexId = "product_" + index;
            
    //         console.log(find("variant-selects .product-form__input"),'indexId');
    //         append_li +=
    //             "<label>" +
    //             option_label +
    //             '</label><ul class="ul_custom_option_value list-unstyled" data-index="' +
    //             indexId +
    //             '" data_attr="' +
    //             option_label +
    //             '"><li class="init ' +
    //             indexId +
    //             ' " data_attr="' +
    //             option_label +
    //             '">Select Option</li>';
    //         $(option_values).each(function(si, sv) {
    //             var opt_v = $.trim($(sv).attr("value"));
    //             var opt_t = $.trim($(sv).text());
    //             var first_active = "";
    //             if (si == 0) {
    //                 var first_active = "active";
    //             }
    //             append_li +=
    //                 '<li class="li_custom_option_value ' +
    //                 first_active +
    //                 '" data_attr="' +
    //                 option_label +
    //                 '"><span style="background: ' +
    //                 opt_v +
    //                 ';" class="span_bg_color"></span><span class="span_custom_option_value" data_value="' +
    //                 opt_v +
    //                 '">' +
    //                 opt_t +
    //                 "</span></li>";
    //         });
    //         append_li += "</ul>";
    //     });
    // var append_ul = '<div class="custom_options_div">' + append_li + "</div>";
    // $("variant-selects").append(append_ul);

    // $(document).on("click", ".li_custom_option_value", function() {
    //     var url = window.location.href;
    //     var parts = url.split("/");
    //     var lastPart = parts[parts.length - 1];

    //     if (lastPart.includes("?")) {
    //         var queryIndex = lastPart.indexOf("?");
    //         lastPart = lastPart.substring(0, queryIndex);
    //     }

    //     var product_handle = lastPart;
    //     var get_attr = $(this).parents(".ul_custom_option_value").attr("data_attr");
    //     var get_value = $(this)
    //         .find(".span_custom_option_value")
    //         .attr("data_value");

    //     $('.ul_custom_option_value[data_attr="' + get_attr + '"] li').each(
    //         function(index) {
    //             $(this).removeClass("active");
    //         }
    //     );

    //     $('select[name="options[' + get_attr + ']"] option').each(function(index) {
    //         $(this).removeAttr("selected");
    //     });

    //     $(this).addClass("active");
    //     $('select[name="options[' + get_attr + ']"]')
    //         .find('option[value="' + get_value + '"]')
    //         .attr("selected", "selected");
    //     $('select[name="options[' + get_attr + ']"]').trigger("change");

    //     var options = "";
    //     $(".ul_custom_option_value li").each(function(index) {
    //         if ($(this).hasClass("active") == true) {
    //             var ot = $.trim($(this).text());
    //             options += "" + ot + " / ";
    //         }
    //     });

    //     options = options.slice(0, -3);
    //     jQuery.getJSON(
    //         window.Shopify.routes.root + "products/" + product_handle + ".js",
    //         function(product) {
    //             var product_v = product.variants;
    //             $('.quantity--error').hide();
    //             $(product_v).each(function(index, value) {
    //                 var title = value.title;
    //                 if (options == title) {
    //                     var minQty = $('.variant-min-qty[value="' + title + '"]').attr('data-qty');
    //                     if (minQty != '') {
    //                         $('.product__info-wrapper .quantity__input').attr('data-min', minQty);
    //                         $('.product__info-wrapper .quantity__input').attr('min', minQty);
    //                         $('.product__info-wrapper .quantity__input').val(minQty);
    //                         $('.quantity--error span').text(minQty);
    //                     } else {
    //                         $('.product__info-wrapper .quantity__input').attr('data-min', 1);
    //                         $('.product__info-wrapper .quantity__input').attr('min', 1);
    //                         $('.product__info-wrapper .quantity__input').val(1);
    //                     }
    //                     $(".product-variant-id").attr("value", value.id);
    //                     $(".product_sku span").text(value.sku);
    //                     $(".price-item--regular").text(Shopify.formatMoney(value.price));
    //                     // var currentURL = new URL(window.location.href);
    //                     // currentURL.searchParams.set("variant", value.id);
    //                     // window.history.replaceState({}, "", currentURL);

    //                     if (productImage != null && productImage !== "") {
    //                         var productImage = value.featured_image.src;
    //                         $("body")
    //                             .find(
    //                                 "ul.product__media-list  li modal-opener .product__media img"
    //                             )
    //                             .attr("srcset", value.featured_image.src);
    //                     }
    //                 }
    //             });
    //         }
    //     );
    // });

    // $(".product-form__submit").click(function(event) {
    //     var selectedOption1 = $(
    //             ".ul_custom_option_value[data-index='product_0'] .init"
    //         )
    //         .text()
    //         .trim();
    //     var selectedOption2 = $(
    //             ".ul_custom_option_value[data-index='product_1'] .init"
    //         )
    //         .text()
    //         .trim();
    //     var selectedOption3 = $(
    //             ".ul_custom_option_value[data-index='product_2'] .init"
    //         )
    //         .text()
    //         .trim();

    //     if (
    //         selectedOption1 === "Select Option" ||
    //         selectedOption2 === "Select Option" ||
    //         selectedOption3 === "Select Option"
    //     ) {
    //         event.preventDefault();
    //         alert("Please select an options before adding to cart.");
    //     }
    // });

    // $(".li_custom_option_value").hide();
    // $(".init").click(function() {
    //     var dropdown = $(this).closest("ul");
    //     var options = dropdown.find(".li_custom_option_value");
    //     options.toggle();
    // });

    // $(".li_custom_option_value").click(function() {
    //     var selectedValue = $(this).find(".span_custom_option_value").text();
    //     var selectedColor = $(this).find(".span_bg_color").css("background-color");

    //     var dropdown = $(this).closest("ul");
    //     var initItem = dropdown.find(".init");

    //     initItem.find(".span_custom_option_value").text(selectedValue);
    //     initItem.find(".span_bg_color").css("background-color", selectedColor);

    //     dropdown.find(".li_custom_option_value").removeClass("selected");
    //     $(this).addClass("selected");

    //     var findLi = $(this).attr("data_attr");
    //     var findAttr1 = dropdown.attr("data-index");

    //     var initItemAttrClass = initItem.attr("class");

    //     var options1 = dropdown.find("li.init[data_attr='" + findLi + "']");
    //     var findText = $(this).html();

    //     options1.html(findText);
    //     dropdown.find(".li_custom_option_value").hide();
    // });

    // /* custom product page code */

    $("legend.form__label, .meta-content").each(function() {
        var legendText = $(this).text();
        if (legendText.includes("(")) {
            var modifiedText = legendText.replace(
                /(.*)\((.*)\)/,
                "$1 <span>($2)</span>"
            );
            $(this).html(modifiedText);
        }
    });

    var elements = document.querySelectorAll("input,select,textarea");

    for (var i = elements.length; i--;) {
        elements[i].addEventListener("invalid", function() {
            this.scrollIntoView(false);
        });
    }

    $(document).on("click", ".apply-filter, facet-remove", function(e) {
        e.preventDefault();
        window.location.href = window.location.href;
    });
});

/* Tabbing Description in PDP */
document.addEventListener(
    "DOMContentLoaded",
    function() {
        $("ul.tabs").each(function() {
            var active,
                content,
                links = $(this).find("a");
            active = links.first().addClass("active");
            content = $(active.attr("href"));
            links.not(":first").each(function() {
                $($(this).attr("href")).hide();
            });
            $(this)
                .find("a")
                .click(function(e) {
                    $("ul.tabs").find("a").removeClass("active");
                    active.removeClass("active");
                    content.hide();
                    active = $(this);
                    content = $($(this).attr("href"));
                    active.addClass("active");
                    content.show();
                    return false;
                });
        });

        $(document).on("click", ".tab_drawer_heading", function() {
            var parent = $(this).parents(".tab-container");
            var activeTab = $(this).attr("rel");
            var isActive = $(this).hasClass("d_active");

            if (isActive) {
                $(parent)
                    .find("#" + activeTab)
                    .slideUp();
                $(this).removeClass("d_active");
            } else {
                $(parent).find(".tab_content").slideUp();
                $(parent).find(".tab_drawer_heading").removeClass("d_active");
                $(parent)
                    .find("#" + activeTab)
                    .slideDown();
                $(this).addClass("d_active");
            }

            $(parent).find("ul.tabs li").removeClass("active");
            $(parent)
                .find("ul.tabs li[rel^='" + activeTab + "']")
                .addClass("active");
        });
    },
    false
);

/* Tabbing Description in PDP */

/* Form Validation start */

document.addEventListener("DOMContentLoaded", function() {
    let form = document.querySelector("#create_customer");
    let firstName = document.querySelector("#RegisterForm-FirstName");
    let lastName = document.querySelector("#RegisterForm-LastName");
    let email = document.querySelector("#RegisterForm-email");
    let companyName = document.querySelector("#RegisterForm-CompanyName");
    let phoneNumber = document.querySelector("#RegisterForm-PhoneNumber");
    let password = document.querySelector("#RegisterForm-password");
    let submitBtn = document.querySelector("#submitBtn");

    var policyCheckbox = document.getElementById("policyCheckbox");

    if (policyCheckbox) {
        policyCheckbox.addEventListener("change", function() {
            if (policyCheckbox.checked) {
                submitBtn.classList.remove("disabled");
                submitBtn.removeAttribute("disabled");
            } else {
                submitBtn.classList.add("disabled");
                submitBtn.setAttribute("disabled", "true");
            }
        });
    }

    if (submitBtn) {
        submitBtn.addEventListener("click", (event) => {
            handleInput(event);
        });
    }

    function handleInput(event) {
        let firstNameValue = firstName.value.trim();
        let lastNameValue = lastName.value.trim();
        let emailValue = email.value.trim();
        let companyNameValue = companyName.value.trim();
        let phoneNumberValue = phoneNumber.value.trim();

        if (firstNameValue === "") {
            setErrorFor(firstName, "First name cannot be blank");
        } else {
            setSuccessFor(firstName);
        }

        if (lastNameValue === "") {
            setErrorFor(lastName, "Last name cannot be blank");
        } else {
            setSuccessFor(lastName);
        }

        if (emailValue === "") {
            setErrorFor(email, "Email cannot be blank");
        } else if (!isEmail(emailValue)) {
            setErrorFor(email, "Email is not valid");
        } else {
            setSuccessFor(email);
        }

        if (companyNameValue === "") {
            setErrorFor(companyName, "Company name cannot be blank");
        } else {
            setSuccessFor(companyName);
        }

        if (containsAlphabet(phoneNumberValue)) {
            event.preventDefault(event);
            setErrorFor(phoneNumber, "Phone number cannot contain alphabets");
            return false;
        } else if (phoneNumberValue === "") {
            event.preventDefault(event);
            setErrorFor(phoneNumber, "Phone number cannot be blank");
            return false;
        } else {
            setSuccessFor(phoneNumber);
        }

        if (password) {
            password.addEventListener("blur", function() {
                validatePassword();
            });
        }

        function validatePassword() {
            let passwordValue = password.value.trim();

            if (passwordValue === "") {
                setErrorFor(password, "Password cannot be blank");
            } else if (passwordValue.length < 6 || passwordValue.length > 30) {
                setErrorFor(password, "Password length should be between 6 and 30");
            } else {
                setSuccessFor(password);
            }
        }

        // Check for password length error
        const passwordError = form.querySelector(
            ".error-message[data-for='RegisterForm-password']"
        );
        if (passwordError) {
            return;
        }

        if (
            form.querySelectorAll(".success").length ===
            form.querySelectorAll(".form-group").length
        ) {
            form.submit();
        }
    }

    function setErrorFor(input, message) {
        let formControl = input.parentElement;
        formControl.classList.remove("success");
        formControl.classList.add("error");
        let errorMessage = formControl.querySelector(".error-message");
        errorMessage.innerText = message;
        errorMessage.style.display = "block";
    }

    function setSuccessFor(input) {
        let formControl = input.parentElement;
        formControl.classList.remove("error");
        formControl.classList.add("success");
        let errorMessage = formControl.querySelector(".error-message");
        errorMessage.style.display = "none";
    }

    function isEmail(email) {
        const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function containsAlphabet(str) {
        // Regular expression to check if the string contains any alphabet characters
        const regex = /[a-zA-Z]/;
        return regex.test(str);
    }
});

/* Form Validation Ends */

$(document).ready(function() {
    // add active class and append arrow on account page

    $(document).on("click", ".left-btn-section", function(event) {
        $(".left-btn-section").removeClass("active").find("i.ico").remove();
        $(this).addClass("active");
        $(this)
            .find("a.link")
            .append('<i class="ico fa fa-angle-right" aria-hidden="true"></i>');
    });

    //open and close the right section on click on my account, settings, order etc on account page

    $(document).on("click", ".left-btn-section", function(event) {
        $(".left-btn-section").removeClass("active");
        $(this).addClass("active");
        if ($(this).hasClass("account-detail")) {
            $(".address-customer").css("display", "block");
            $(".setting-customer-detail").css("display", "none");
            $(".customer-history-page").css("display", "none");
            $(".customer-account-reset").css("display", "none");
        } else if ($(this).hasClass("order-detail")) {
            $(".customer-history-page").css("display", "block");
            $(".setting-customer-detail").css("display", "none");
            $(".address-customer").css("display", "none");
            $(".customer-account-reset").css("display", "none");
        } else if ($(this).hasClass("account-settings")) {
            $(".setting-customer-detail").css("display", "block");
            $(".address-customer").css("display", "none");
            $(".customer-history-page").css("display", "none");
            $(".customer-account-reset").css("display", "none");
        } else if ($(this).hasClass("reset-password")) {
            $(".customer-account-reset").css("display", "block");
            $(".setting-customer-detail").css("display", "none");
            $(".address-customer").css("display", "none");
            $(".customer-history-page").css("display", "none");
        }
    });

    $(".edit-btn").click(function() {
        $(this).parents("li").find(".add_new_adds").css("display", "none");
        $(this).parents("li").find(".edit_adds").toggle();
    });

    $(".add-address").click(function() {
        $(this).parents("li").find(".edit_adds").css("display", "none");
        $(this).parents("li").find(".add_new_adds").toggle();
        $(".section-account-btn")
            .not($(this).siblings(".section-account-btn"))
            .hide();
    });

    // remove "from lable" from product page above price when color variant changed

    $(".li_custom_option_value").on("click", function() {
        $(".li_custom_option_value.selected").removeClass("selected");
        $(".from_txt").hide();
        $(this).addClass("selected");
        $(".variant-from-lable").hide();
    });

    //button disable on click on account > settings

    $(".edit-personal-info").click(function() {
        var parentContainer = $(this).closest(".address_bx");
        parentContainer.find(".personal-info-input").removeAttr("readonly");
        parentContainer.find(".edit-detail-btn").show();
    });

    $(".info-edit-text").click(function() {
        var parentContainer = $(this).closest(".address_bx");
        parentContainer.find(".address-info-input").removeAttr("readonly");
        parentContainer.find(".address-info-input").removeAttr("disabled");
        parentContainer.find(".edit-address-btn").show();
    });
});

// Get In Touch validation
// https://galaxysys.myshopify.com/pages/support
$(document).ready(function() {
    let form = $("#create_customer");
    let firstName = $("#RegisterForm-FirstName");
    let lastName = $("#RegisterForm-LastName");
    let email = $("#RegisterForm-email");
    let companyName = $("#RegisterForm-CompanyName");
    let delar = $("#RegisterForm-dealer");
    let phoneNumber = $("#RegisterForm-PhoneNumber");
    let policyCheckbox = $("#policyCheckbox");
    let submitBtn = $("#submitBtn");

    policyCheckbox.change(function() {
        if (policyCheckbox.prop("checked")) {
            submitBtn.removeClass("disabled");
            submitBtn.removeAttr("disabled");
        } else {
            submitBtn.addClass("disabled");
            submitBtn.attr("disabled", "true");
        }
    });

    submitBtn.click(function() {
        handleInput();
    });

    function handleInput() {
        let firstNameValue = firstName.val().trim();
        let lastNameValue = lastName.val().trim();
        let emailValue = email.val().trim();
        let companyNameValue = companyName.val().trim();
        let phoneNumberValue = phoneNumber.val().trim();
        let delarValue = delar.val().trim();

        if (firstNameValue === "") {
            setErrorFor(firstName, "First name cannot be blank");
        } else {
            setSuccessFor(firstName);
        }

        if (lastNameValue === "") {
            setErrorFor(lastName, "Last name cannot be blank");
        } else {
            setSuccessFor(lastName);
        }

        if (emailValue === "") {
            setErrorFor(email, "Email cannot be blank");
        } else if (!isEmail(emailValue)) {
            setErrorFor(email, "Email is not valid");
        } else {
            setSuccessFor(email);
        }

        if (companyNameValue === "") {
            setErrorFor(companyName, "Company name cannot be blank");
        } else {
            setSuccessFor(companyName);
        }

        if (delarValue === "") {
            setErrorFor(delar, "Dealer ID Can not be blank");
        } else {
            setSuccessFor(delar);
        }

        if (phoneNumberValue === "") {
            setErrorFor(phoneNumber, "Phone number cannot be blank");
        } else if (!isValidPhoneNumber(phoneNumberValue)) {
            setErrorFor(phoneNumber, "Only numbers are allowed");
        } else {
            setSuccessFor(phoneNumber);
        }

        if (phoneNumberValue === "") {
            setErrorFor(phoneNumber, "Phone number cannot be blank");
        } else if (!isValidPhoneNumber(phoneNumberValue)) {
            setErrorFor(phoneNumber, "Only numbers are allowed");
        } else {
            setSuccessFor(phoneNumber);
        }

        function isValidPhoneNumber(phoneNumber) {
            const phoneRegex = /^\d+$/;
            return phoneRegex.test(phoneNumber);
        }

        phoneNumber.on("input", function() {
            if (/[a-zA-Z]/.test(phoneNumber.val())) {
                setErrorFor(phoneNumber, "Phone number should only contain numbers");
            } else {
                setSuccessFor(phoneNumber);
            }
        });

        // Check for password length error
        // Password-related code removed

        if (form.find(".success").length === form.find(".form-group").length) {
            form.submit();
        }
    }

    function setErrorFor(input, message) {
        let formControl = input.parent();
        formControl.removeClass("success");
        formControl.addClass("error");
        let errorMessage = formControl.find(".error-message");
        errorMessage.text(message);
        errorMessage.css("display", "block");
    }

    function setSuccessFor(input) {
        let formControl = input.parent();
        formControl.removeClass("error");
        formControl.addClass("success");
        let errorMessage = formControl.find(".error-message");
        errorMessage.css("display", "none");
    }

    function isEmail(email) {
        const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    var intervalId = setInterval(function() {
        $('.boost-sd__button').each(function(index) {
            var $productItem = $(this).parents('.boost-sd__product-item');
            var productUrl = $productItem.find('.boost-sd__product-link').attr('href');
            if (typeof productUrl !== "undefined" && productUrl !== false) {
                var urlParts = productUrl.split('/');
                var product_handle = urlParts[urlParts.length - 1];
            }
            jQuery.getJSON(
                window.Shopify.routes.root + "products/" + product_handle + ".js",
                function(product) {
                    $productItem.find('.boost-sd__button').before('<p class="description-product">"' + product.description + '"</p>');
                }
            );
        });
        $('.boost-sd__button').addClass('boost-custom')
        $('.boost-sd__product-price').hide();

        $('button[aria-label="Choose options"]').each(function(index) {
            var productPriceElement = $(this).parents('.boost-sd__product-item').find('.boost-sd__product-price').find('.boost-sd__format-currency span');
            var productPriceText = productPriceElement.text();
            var numericPrice = parseFloat(productPriceText.replace(/[^\d.]/g, ''), 10);
            var formattedPrice = '$' + numericPrice.toLocaleString();
            $(this).find('.boost-sd__button-text').text('Quick View | ' + formattedPrice + '.00');
        });

        $('button[aria-label="Add to cart"]').each(function(index) {
            var productPriceElement = $(this).parents('.boost-sd__product-item').find('.boost-sd__product-price').find('.boost-sd__format-currency span');
            var productPriceText = productPriceElement.text();
            var numericPrice = parseFloat(productPriceText.replace(/[^\d.]/g, ''), 10);
            var formattedPrice = '$' + numericPrice.toLocaleString();
            $(this).find('.boost-sd__button-text').text('Add to cart | ' + formattedPrice + '.00');
        });

        if ($('.boost-custom').length > 0) {
            clearInterval(intervalId);
        }
    }, 2500);

    $(document).on("click", ".block__product-details input", function(event) {
        var price = 0;
        $(this).closest('.product__info-container').find('.block__product-details').each(function() {
            var var_price = $(this).find('input:checked').attr('data-price');
            if (var_price !== undefined) {
                var add_price = parseInt(var_price);
                price += add_price;
            }
        });
        $(".block__selected-product-price").html(Shopify.formatMoney(price));
    });

    var price = 0;
    $('.product__info-container').find('.block__product-details').each(function() {
        var var_price = $(this).find('input:checked').attr('data-price');
        if (var_price !== undefined) {
            var add_price = parseInt(var_price);
            price += add_price;
        }
    });
    $(".block__selected-product-price").html(Shopify.formatMoney(price));

});

// Custom Pagination for wholesale order list collection
jQuery(document).ready(function() {
    var show_per_page = 4;
    var number_of_items = $('.wholesale-order-box--wrapper').children().length;
    var number_of_pages = Math.ceil(number_of_items / show_per_page);
    $('#current_page').val(0);
    $('#show_per_page').val(show_per_page);
    var navigation_html = '<a class="arrow-btn previous_link" href="javascript:previous();"><svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M6 1L1 6L6 11" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>';
    var current_link = 0;
    while (number_of_pages > current_link) {
        navigation_html += '<a class="page_link" href="javascript:go_to_page(' + current_link + ')" longdesc="' + current_link + '">' + (current_link + 1) + '</a>';
        current_link++;
    }
    navigation_html += '<a class="arrow-btn next_link" href="javascript:next();"><svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1L6 6L1 11" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>';
    $('#page_navigation').html(navigation_html);
    $('#page_navigation .page_link:first').addClass('active_page');
    $('.wholesale-order-box--wrapper').children().css('display', 'none');
    $('.wholesale-order-box--wrapper').children().slice(0, show_per_page).css('display', 'block');

});

function previous() {
    new_page = parseInt($('#current_page').val()) - 1;
    if ($('.active_page').prev('.page_link').length == true) {
        go_to_page(new_page);
    }
}

function next() {
    new_page = parseInt($('#current_page').val()) + 1;
    if ($('.active_page').next('.page_link').length == true) {
        go_to_page(new_page);
    }
}

function go_to_page(page_num) {
    var show_per_page = parseInt($('#show_per_page').val());
    start_from = page_num * show_per_page;
    end_on = start_from + show_per_page;
    $('.wholesale-order-box--wrapper').children().css('display', 'none').slice(start_from, end_on).css('display', 'block');
    $('.page_link[longdesc=' + page_num + ']').addClass('active_page').siblings('.active_page').removeClass('active_page');
    $('#current_page').val(page_num);
}


$(window).on("load", function() {
    $(".usb-related-product-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: false,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

$(document).ready(function(){
    $(document).on("click",".quickorder-button .block__btn-txt ", function(){
        $('cart-drawer').addClass('active');
        $('body').addClass('overflow-hidden');
      });
});

// Product Sticky
const stickyDiv = document.querySelector('.product-sticky');
const triggerElement = document.querySelector('.product--thumbnail_slider');

if (stickyDiv && triggerElement) {
    new IntersectionObserver(([entry]) => {
        stickyDiv.classList.toggle('product-is-sticky', !entry.isIntersecting);
    }).observe(triggerElement);
}

// Product Sticky Trigger
  document.addEventListener('DOMContentLoaded', () => {
    const productbutton = document.querySelector('.product-main-inner-button');
    if (productbutton) {
        productbutton.addEventListener('click', () => {
            const submitButton = document.querySelector('.product-form__buttons .product-form__submit[type="submit"]');
            if (submitButton) {
                submitButton.click();
            } else {
            }
        });
    } else {
    }
});

 // Wholesale Page SearchBar

  $(document).on("input",".block__collection-wholesale-search-input",function(){
    var term = $(this).val();
    if (term.length != '') {
      if(term.length >= 3){
        var searchURL = '/search?type=product&q=' + term +"&view=wholesale-quick";      
        $.ajax({
          url: searchURL,
          type: 'GET',
          dataType: 'html',
          success:function(wholesalehtml) {  
            
            $(".block__collection-wholesale-search-input").attr("value" , term);
            const parsedHTML = $(wholesalehtml);
            console.log(wholesalehtml);
            $('.product-grid-container #product-grid').html(parsedHTML.find('.product-grid-container #product-grid').html());
            $(".pagination-wrapper").addClass("hidden");
            // Re-run QuickOrderList logic after DOM update
            setTimeout(function(){
                console.log("dsfsf");
                // This removes the element from the DOM and triggers disconnectedCallback
                //document.querySelectorAll('quick-order-list').forEach(el => el.remove());
                // function removeScriptBySrc(srcUrl) {
                //     const scripts = document.querySelectorAll('script[src]');
                //     scripts.forEach((script) => {
                //         if (script.src.includes(srcUrl)) {
                //         script.remove();
                //         }
                //     });
                // }

                //     // Example usage:
                //     removeScriptBySrc('//galaxysys.myshopify.com/cdn/shop/t/81/assets/quick-order-list.js?v=24106112019734145701753875193');
            },1000);
            
          },
          error: function (error) {
            console.log(error.responseJSON.description);
          }     
        });
      }
    }else{
      var url = $(this).attr("data-url");
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        success:function(wholesalehtml) {         
         $('.product-grid').html($(wholesalehtml).find('.product-grid').html());
            $(".pagination-wrapper").removeClass("hidden");
        },
        error: function (error) {
          console.log(error.responseJSON.description);
        }     
      });
    }
  });

//   Header megamenu open close
document.querySelectorAll('.header__inline-menu .header__menu-item').forEach(item => {
  item.addEventListener('click', function (e) {
    e.preventDefault();

    const parentMenu = this.closest('.mega-menu');
    const content = parentMenu.querySelector('.mega-menu__content');

    // If the clicked menu is already open → close it
    if (parentMenu.classList.contains('menu-open')) {
      parentMenu.classList.remove('menu-open');
      content?.classList.remove('open');
      return;
    }

    // Close all other menus
    document.querySelectorAll('.mega-menu').forEach(menu => {
      menu.classList.remove('menu-open');
      menu.querySelector('.mega-menu__content')?.classList.remove('open');
    });

    // Open clicked one
    parentMenu.classList.add('menu-open');
    content?.classList.add('open');
  });
});

// Close menu if click outside
document.addEventListener('click', function (e) {
  if (
    !e.target.closest('.mege-menu__wrapper') &&
    !e.target.closest('.header__menu-item')
  ) {
    document.querySelectorAll('.mega-menu').forEach(menu => {
      menu.classList.remove('menu-open');
      menu.querySelector('.mega-menu__content')?.classList.remove('open');
    });
  }
}); 